import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { settingsApiSlice } from "./settingsApi";
import { dynamicApiSlice } from "./dynamicApi";
import { workflowDefinitionsApi } from "./workflows/workflowDefinitionsApi";
import {
  newWorkflowSlice,
  workflowSearchSlice,
  signalrReducer,
  feedbackSlice,
} from "@/features";
import { feedbackFormReducer } from "@/features/shared/feedbackFormSlice";
import { manageAccessSlice } from "@/features/overlays/manageAccessSlice";
import { notificationsApiSlice } from "./notifications/notificationsApi";
import { workflowInstancesApi } from "./workflows/workflowInstancesApi";
import { workflowReducer } from "@/features/workflow/workflowSlice";
import { outputStateReducer } from "@/features/workflow/outputStateSlice";
import { workflowInstanceReducer } from "@/features/workflow-instance/workflowInstanceSlice";
import { fileUploadReducer } from "@/features/new-workflow/fileUploadSlice";

export const store = configureStore({
  reducer: {
    api: settingsApiSlice.reducer,
    dynamicApi: dynamicApiSlice.reducer,
    notificationsApi: notificationsApiSlice.reducer,
    workflowDefinitionsApi: workflowDefinitionsApi.reducer,
    workflowInstancesApi: workflowInstancesApi.reducer,
    newWorkflow: newWorkflowSlice.reducer,
    workflowSearch: workflowSearchSlice.reducer,
    signalr: signalrReducer,
    fileUpload: fileUploadReducer,
    feedback: feedbackSlice.reducer,
    feedbackForm: feedbackFormReducer,
    manageAccess: manageAccessSlice.reducer,
    workflow: workflowReducer,
    workflowInstance: workflowInstanceReducer,
    outputState: outputStateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(settingsApiSlice.middleware)
      .concat(dynamicApiSlice.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
